import { connect } from 'react-redux'
import SchoolFilesEntry from './school-files-entry'
import { getSchoolFile } from '../../../../../../stores/school-files/school-files.selectors'
import { format } from 'date-fns'

const mapStateToProps = (state, { id }) => {
  const schoolFile = getSchoolFile(state, id)
  return {
    id: schoolFile.id,
    title: schoolFile.title,
    createdAt: format(schoolFile.created_at, 'DD.MM.YYYY'),
    link: `/assessment-files/${schoolFile.id}`,
    conclusion: schoolFile.concluded,
    benchmarked: schoolFile.benchmarked,
    students:
      schoolFile.student_types &&
      schoolFile.student_types
        .map(student => student.full_name + ', ')
        .toString()
        .slice(0, -2),
    thumb:
      schoolFile.works &&
      schoolFile.works[0] &&
      schoolFile.works[0].media &&
      schoolFile.works[0].media[0] &&
      schoolFile.works[0].media[0].thumb_url,
    author: schoolFile.teacher_type && schoolFile.teacher_type.full_name,
    moderationType:
      schoolFile.moderation_type &&
      schoolFile.moderation_type.replace(/_/g, ' '),
    judgement: schoolFile.judgement && schoolFile.judgement.replace(/_/g, ' '),
    judgementShort: checkJudgment(schoolFile.judgement),
    ageGroupTitle:
      schoolFile.works &&
      schoolFile.works[0] &&
      schoolFile.works[0].year_group &&
      schoolFile.works[0].year_group.title,
    ageGroupOrder:
      schoolFile.works &&
      schoolFile.works[0] &&
      schoolFile.works[0].year_group &&
      schoolFile.works[0].year_group.order
  }
}

function checkJudgment(judgement) {
  return judgement === 'greater_depth_within_the_expected_standard'
    ? 'GDS'
    : judgement === 'working_towards_the_expected_standard'
    ? 'WTS'
    : judgement === 'working_at_the_expected_standard'
    ? 'EXS'
    : judgement === 'eyfs_emerging'
    ? 'EYFS Emerging'
    : judgement === 'eyfs_expected'
    ? 'EYFS Expected'
    : '-'
}

export default connect(
  mapStateToProps,
  null
)(SchoolFilesEntry)
